import {
  formatReceiptDateTime,
  formatReceiptMoney,
  getReceiptGuestLabel,
  receiptLineDescriptions,
} from '@/components/pos/posReceipt'

/**
 * @param {object} props
 * @param {import('@/types/api').PosReceipt | null} props.receipt
 */
export function PosThermalReceipt({ receipt }) {
  if (!receipt) return null

  const currency = receipt.sale?.currency_code ?? 'AED'

  return (
    <div className="thermal-receipt-root pointer-events-none fixed -left-[9999px] top-0">
      <article className="thermal-receipt" aria-label="Thermal receipt">
        <header className="thermal-receipt__header">
          <p className="thermal-receipt__title">{receipt.company?.name ?? receipt.branch?.name}</p>
          <p>{receipt.branch?.name}</p>
          {receipt.branch?.address ? <p>{receipt.branch.address}</p> : null}
          {receipt.branch?.phone ? <p>Tel: {receipt.branch.phone}</p> : null}
          {receipt.branch?.trn ? <p>TRN: {receipt.branch.trn}</p> : null}
        </header>

        <section className="thermal-receipt__meta">
          <Row label="Receipt" value={receipt.sale?.sale_number ?? ''} />
          <Row label="Date" value={formatReceiptDateTime(receipt.sale?.completed_at)} />
          <Row label="Guest" value={getReceiptGuestLabel(receipt)} />
        </section>

        <section className="thermal-receipt__lines">
          {(receipt.lines ?? []).map((line, index) => {
            const descriptions = receiptLineDescriptions(line)

            return (
            <div key={`${line.description}-${index}`} className={line.is_addon ? 'thermal-receipt__addon' : ''}>
              <div className="thermal-receipt__row">
                <span>
                  {line.is_addon ? '+ ' : ''}
                  {descriptions[0].text}
                  {line.quantity > 1 ? ` x${line.quantity}` : ''}
                </span>
                <span>{formatReceiptMoney(line.line_total, currency)}</span>
              </div>
              {descriptions[1] ? (
                <p className="thermal-receipt__line-ar" dir="rtl">{descriptions[1].text}</p>
              ) : null}
              {line.stylist_name ? (
                <p className="thermal-receipt__stylist">Stylist: {line.stylist_name}</p>
              ) : null}
            </div>
            )
          })}
        </section>

        <section className="thermal-receipt__totals">
          <Row label="Subtotal" value={formatReceiptMoney(receipt.totals?.subtotal, currency)} />
          {Number(receipt.totals?.discount) > 0 ? (
            <Row label="Discount" value={`-${formatReceiptMoney(receipt.totals.discount, currency).replace(`${currency} `, '')}`} />
          ) : null}
          <Row label={receipt.tax_label ?? 'VAT'} value={formatReceiptMoney(receipt.totals?.tax, currency)} />
          {Number(receipt.totals?.tip) > 0 ? (
            <Row label="Tip" value={formatReceiptMoney(receipt.totals.tip, currency)} />
          ) : null}
          <div className="thermal-receipt__row thermal-receipt__total">
            <span>TOTAL</span>
            <span>{formatReceiptMoney(receipt.totals?.total, currency)}</span>
          </div>
        </section>

        <section className="thermal-receipt__payments">
          {(receipt.payments ?? []).map((payment, index) => (
            <Row
              key={`${payment.method_code ?? payment.method_name}-${index}`}
              label={payment.reference ? `${payment.method_name} (${payment.reference})` : payment.method_name ?? 'Payment'}
              value={formatReceiptMoney(payment.amount, currency)}
            />
          ))}
        </section>

        {receipt.footer ? (
          <footer className="thermal-receipt__footer">{receipt.footer}</footer>
        ) : null}
      </article>
    </div>
  )
}

/**
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.value
 */
function Row({ label, value }) {
  return (
    <div className="thermal-receipt__row">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  )
}
